module.exports = __webpack_public_path__ + "f35f12014dc5a47d62344c9eda704616.svg";